import React, { Component } from 'react';

export class Home extends Component {
  static displayName = Home.name;

  render() {
    return (
      <div>
        <h1>modeltrader.ai</h1>
        <p>This web app makes trading easy.</p>
      </div>
    );
  }
}
